import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { NOT_STARTED, IN_PROGRESS, COMPLETE, ERROR } from '@/lib/constants/actionStatuses'
import { PATH_DIRECT_PLACEMENT_PAYMENTS } from '@/lib/constants/api'
import getDirectPlacementPaymentModel from './models/directPlacementPayment'
import updateStatus from '@/store/helpers/updateStatus'
import { notifySuccess, notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const directPlacementPayment = {
  namespaced: true,
  state: {
    ...getDirectPlacementPaymentModel()
  },
  getters: {
    getField
  },
  mutations: {
    updateField,
    updateStatus,
    clearDirectPlacementPayment: (state) => {
      state.id = 0
      state.directPlacementId = null
      state.receivedAt = null
      state.amount = null
      state.paymentNotes = null
      state.createdBy = null
      state.createdAt = null
      state.updatedAt = null
      state.updatedBy = null
    },
    setDirectPlacementPayment: (state, directPlacementPayment) => {
      state.id = directPlacementPayment.id
      state.directPlacementId = directPlacementPayment.directPlacementId
      state.receivedAt = directPlacementPayment.receivedAt
      state.amount = directPlacementPayment.amount
      state.paymentNotes = directPlacementPayment.paymentNotes
      state.createdBy = directPlacementPayment.createdBy
      state.createdAt = directPlacementPayment.createdAt
      state.updatedAt = directPlacementPayment.updatedAt
      state.updatedBy = directPlacementPayment.updatedBy
    }
  },
  actions: {
    save ({ state }) {
      return api.doPost({ path: PATH_DIRECT_PLACEMENT_PAYMENTS, data: state })
    },
    update ({ state }) {
      return api.doPut({ path: PATH_DIRECT_PLACEMENT_PAYMENTS, data: state })
    },
    getDirectPlacementPayment: ({ commit, dispatch }, { id }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting perm. placement payment, please wait...' })

      return api.doGet({ path: PATH_DIRECT_PLACEMENT_PAYMENTS, parameters: { id } })
        .then(json => json.data)
        .then(directPlacementPayment => {
          commit('setDirectPlacementPayment', directPlacementPayment)
          commit('updateStatus', { status: COMPLETE })
          return directPlacementPayment
        }).catch((error) => {
          commit('updateStatus', { status: ERROR, error })
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    saveDirectPlacementPayment: ({ state, commit, dispatch }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Saving payment, please wait...' })
      const actionName = state.id ? 'update' : 'save'
      return dispatch(actionName).then(response => {
        if (!response.data) {
          throw new Error('Unable to save payment. Check required fields.')
        } else {
          commit('updateStatus', { status: COMPLETE })
          notifySuccess(dispatch, 'Payment saved')
        }
        return response
      }).catch((error) => {
        commit('updateStatus', { status: ERROR, error })
        notifyError(dispatch, 'Unable to save payment. Try again later')
        throw error
      })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    clearDirectPlacementPayment: ({ commit }) => {
      commit('clearDirectPlacementPayment')
      return commit('updateStatus', { status: NOT_STARTED })
    },
    deleteDirectPlacementPayment ({ commit, dispatch }, id = null) {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Deleting payment, please wait...' })
      return api.doDelete({ path: PATH_DIRECT_PLACEMENT_PAYMENTS, parameters: Object.assign({}, { id: id }) })
        .then(response => {
          if (!response.data) {
            throw new Error('Unable to delete payment')
          } else {
            commit('updateStatus', { status: COMPLETE })
            notifySuccess(dispatch, 'Payment deleted')
          }
          return response.data
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to delete payment')
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    }
  }
}

export default directPlacementPayment
